module.exports = __webpack_public_path__ + "SF-UI-Display-Medium.4123a8a94268c6d26b45.otf";


//////////////////
// WEBPACK FOOTER
// D:/UI-PROJECTS/Helpline1097-UI/src/fonts/SF-UI-Display/SF-UI-Display-Medium.otf
// module id = ../../../../../src/fonts/SF-UI-Display/SF-UI-Display-Medium.otf
// module chunks = 2